import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import api from '../../utils/api';
import { useTenant } from '../../context/TenantContext';

const HoldedIntegration = () => {
  const { activeTenant } = useTenant();
  const [status, setStatus] = useState('DISCONNECTED');
  const [apiKey, setApiKey] = useState('');

  const loadStatus = async () => {
    if (!activeTenant) return;
    try {
      const res = await api.get(`/integrations?tenant_id=${activeTenant}`);
      const holded = (res.data || []).find((item) => item.provider === 'HOLDED');
      setStatus(holded?.status || 'DISCONNECTED');
    } catch (error) {
      setStatus('DISCONNECTED');
    }
  };

  useEffect(() => {
    loadStatus();
  }, [activeTenant]);

  const handleConnect = async () => {
    if (!apiKey) {
      toast.error('Introduce la clave API');
      return;
    }
    try {
      await api.post('/integrations/holded/connect', { tenant_id: activeTenant, api_key: apiKey });
      toast.success('Holded conectado');
      setApiKey('');
      loadStatus();
    } catch (error) {
      toast.error('Error al conectar Holded');
    }
  };

  const handleTest = async () => {
    try {
      await api.post(`/integrations/holded/test?tenant_id=${activeTenant}`);
      toast.success('Conexion correcta');
    } catch (error) {
      toast.error('Error al probar Holded');
    }
  };

  const handleDisconnect = async () => {
    try {
      await api.post(`/integrations/holded/disconnect?tenant_id=${activeTenant}`);
      toast.success('Holded desconectado');
      loadStatus();
    } catch (error) {
      toast.error('Error al desconectar');
    }
  };

  return (
    <div className="max-w-4xl mx-auto space-y-6" data-testid="client-holded-page">
      <div>
        <h1 className="text-4xl font-heading font-bold">Integracion Holded</h1>
        <p className="text-muted-foreground">Conecta tu cuenta para exportar datos automaticamente.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Estado: {status}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Clave API</Label>
            <Input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Holded API Key"
            />
          </div>
          <div className="flex flex-wrap gap-2">
            <Button onClick={handleConnect}>Conectar</Button>
            <Button variant="outline" onClick={handleTest}>Probar conexion</Button>
            <Button variant="ghost" onClick={handleDisconnect}>Desconectar</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default HoldedIntegration;
